import Aod from '@mui/icons-material/Aod';
import Monitor from '@mui/icons-material/Monitor';
import { ListItemIcon, ListItemText } from '@mui/material';
import React from 'react';

import { DataGridDensityMenuItemsProps } from './DataGridDensityMenuItems.props';
import { CustomDensityOption } from '../../../@types';
import { Typography, TypographyVariantProps } from '../Typography';
import { StyledMenuItem } from './DataGridDensityMenuItems.styles';

export const DataGridDensityMenuItems: React.FC<DataGridDensityMenuItemsProps> = ({
  selectedDesityOption,
  onDensityChange
}) => {
  return (
    <>
      <StyledMenuItem onClick={() => onDensityChange(CustomDensityOption.Default) } selected={selectedDesityOption === CustomDensityOption.Default}>
        <ListItemIcon>
          <Monitor fontSize="small" />
        </ListItemIcon>
        <ListItemText><Typography variant={TypographyVariantProps.Body2}>Default</Typography></ListItemText>
      </StyledMenuItem>
      <StyledMenuItem onClick={() => onDensityChange(CustomDensityOption.Mobile) } selected={selectedDesityOption === CustomDensityOption.Mobile}>
        <ListItemIcon>
          <Aod fontSize="small" />
        </ListItemIcon>
        <ListItemText><Typography variant={TypographyVariantProps.Body2}>Mobile</Typography></ListItemText>
      </StyledMenuItem>
    </>
  );
};